var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReporteVentas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-reporte-ventas",
    transform: "translate(14639 18568)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2075",
    "data-name": "Rect\\xE1ngulo 2075",
    width: 46,
    height: 46,
    transform: "translate(-14639 -18568)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "chart-mixed-svgrepo-com",
    d: "M3,30.823V24.64m9.584,6.183V18.457m9.584,12.366V21.549m9.584,9.274V15.366M11.688,6.958a2.453,2.453,0,0,0,3.389,0m-3.389,0a2.275,2.275,0,0,1-.7-1.64,2.4,2.4,0,0,1,4.792,0,2.275,2.275,0,0,1-.7,1.64m-3.389,0-4.6,4.45m0,0A2.429,2.429,0,0,0,5.4,10.729a2.32,2.32,0,1,0,0,4.637,2.358,2.358,0,0,0,2.4-2.319A2.275,2.275,0,0,0,7.09,11.408Zm7.987-4.45,4.6,4.45m0,0a2.275,2.275,0,0,0-.7,1.64,2.4,2.4,0,0,0,4.792,0,2.275,2.275,0,0,0-.7-1.64m-3.389,0a2.453,2.453,0,0,1,3.389,0m0,0,4.6-4.45m0,0a2.429,2.429,0,0,0,1.694.679,2.358,2.358,0,0,0,2.4-2.319,2.4,2.4,0,0,0-4.792,0A2.275,2.275,0,0,0,27.662,6.958Z",
    transform: "translate(-14633.5 -18562.406)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReporteVentas);
export default __webpack_public_path__ + "static/media/icon-reporte-ventas.cb87c101794b50391a01858627ceb2fd.svg";
export { ForwardRef as ReactComponent };